import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const ParallaxSection = ({ image, children, className = "min-h-[80vh]", overlay = "bg-slate-900/45", speed = 25, testid }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${speed}%`, `${speed}%`]);
  return (
    <section ref={ref} className={`relative overflow-hidden ${className}`} data-testid={testid}>
      <motion.div style={{ y }} className="absolute -inset-y-[30%] inset-x-0">
        <img src={image} alt="" className="h-full w-full object-cover" />
      </motion.div>
      <div className={`absolute inset-0 ${overlay}`} />
      <div className="relative z-10 h-full">{children}</div>
    </section>
  );
};
